import React from 'react';

import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';
import { BaseCardProps } from '@bcp-nextgen-dx-component-factory/design-system';

import { CardBaseAb } from './cardBase.ab';
import { CardBaseBcp } from './cardBase.bcp';

export const CardBase: React.FC<BaseCardProps> = (props: BaseCardProps): JSX.Element => {
	return (
		<RenderComponent
			components={{
				ab: { desktop: <CardBaseAb {...props} />, mobile: <CardBaseAb {...props} />, intranet: null },
				bcp: { desktop: <CardBaseBcp {...props} />, mobile: <CardBaseBcp {...props} />, intranet: null },
			}}
		/>
	);
};

export default CardBase;
